import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { ConfirmComponent } from './confirm.component'

@NgModule({
  imports: [
    CommonModule,
    DirectivesModule,
    MatDialogModule,
    MatButtonModule,
    FlexLayoutModule,
    MatIconModule,
    TranslateModule,
  ],
  exports: [
    ConfirmComponent,
  ],
  declarations: [
    ConfirmComponent,
  ],
})
export class ConfirmModule {}
